export default __webpack_public_path__ + "static/media/ChevronDownBlack.84b674a6.svg";